import * as React from 'react';

function Ideal(props) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1_720)">
                <rect width="32" height="32" rx="16" fill="white" />
                <g clipPath="url(#clip1_1_720)">
                    <path
                        d="M6.0072 7.55671V25.4433C6.0072 26.2995 6.68303 27 7.50904 27H17.8191C25.6137 27 28.9928 22.4778 28.9928 16.4766C28.9928 10.5067 25.6137 6 17.8191 6H7.50904C6.68303 6 6.0072 6.70052 6.0072 7.55671Z"
                        fill="white"
                    />
                    <path
                        d="M12.9081 10.3899V23.6064H18.4574C23.4961 23.6064 25.6813 20.6564 25.6813 16.4844C25.6813 12.4915 23.4961 9.39362 18.4574 9.39362H13.8693C13.3362 9.39362 12.9081 9.84507 12.9081 10.3899Z"
                        fill="#CC0066"
                    />
                    <path
                        d="M17.8191 25.5756H8.85319C8.05721 25.5756 7.41142 24.9062 7.41142 24.0812V8.92661C7.41142 8.10156 8.05721 7.43217 8.85319 7.43217H17.8191C26.327 7.43217 27.5961 13.1064 27.5961 16.4844C27.5961 22.3454 24.1193 25.5756 17.8191 25.5756ZM8.85319 7.93032C8.32003 7.93032 7.89201 8.37398 7.89201 8.92661V24.0812C7.89201 24.6338 8.32003 25.0775 8.85319 25.0775H17.8191C23.8115 25.0775 27.1155 22.0263 27.1155 16.4844C27.1155 9.04337 21.2884 7.93032 17.8191 7.93032H8.85319Z"
                        fill="black"
                    />
                    <path
                        d="M14.8605 14.702C15.0558 14.702 15.236 14.7331 15.4087 14.7954C15.5814 14.8577 15.7241 14.9589 15.8517 15.0834C15.9719 15.2157 16.0695 15.3792 16.1446 15.566C16.2122 15.7606 16.2497 15.9863 16.2497 16.2509C16.2497 16.4844 16.2197 16.6946 16.1671 16.8892C16.107 17.0838 16.0244 17.255 15.9118 17.3951C15.7992 17.5352 15.6565 17.6442 15.4838 17.7298C15.3111 17.8076 15.1083 17.8543 14.8755 17.8543H13.5614V14.6942H14.8605V14.702ZM14.8155 17.2783C14.9131 17.2783 15.0032 17.2628 15.1008 17.2316C15.1909 17.2005 15.2735 17.146 15.3411 17.0682C15.4087 16.9904 15.4688 16.897 15.5138 16.7724C15.5589 16.6479 15.5814 16.5078 15.5814 16.3288C15.5814 16.1731 15.5664 16.0252 15.5363 15.9007C15.5063 15.7761 15.4537 15.6594 15.3862 15.5738C15.3186 15.4881 15.2285 15.4103 15.1158 15.3636C15.0032 15.3169 14.868 15.2935 14.7028 15.2935H14.2222V17.2861H14.8155V17.2783Z"
                        fill="white"
                    />
                    <path
                        d="M18.9605 14.702V15.2858H17.3536V15.9629H18.8329V16.5H17.3536V17.2706H18.9981V17.8543H16.6853V14.6942H18.9605V14.702Z"
                        fill="white"
                    />
                    <path
                        d="M21.2583 14.702L22.3997 17.8621H21.7014L21.4686 17.1616H20.3272L20.0869 17.8621H19.4111L20.56 14.702H21.2583ZM21.2959 16.6401L20.9129 15.4804H20.9054L20.5074 16.6401H21.2959Z"
                        fill="white"
                    />
                    <path
                        d="M23.4886 14.702V17.2783H24.9754V17.8621H22.8203V14.702H23.4886Z"
                        fill="white"
                    />
                    <path
                        d="M10.4001 17.7376C11.1756 17.7376 11.8043 17.0859 11.8043 16.2821C11.8043 15.4782 11.1756 14.8265 10.4001 14.8265C9.62454 14.8265 8.99585 15.4782 8.99585 16.2821C8.99585 17.0859 9.62454 17.7376 10.4001 17.7376Z"
                        fill="black"
                    />
                    <path
                        d="M11.4589 23.6064C10.2799 23.6064 9.33377 22.6179 9.33377 21.4036V19.6835C9.33377 19.0764 9.80685 18.5782 10.4001 18.5782C10.9858 18.5782 11.4664 19.0686 11.4664 19.6835V23.6064H11.4589Z"
                        fill="black"
                    />
                </g>
            </g>
            <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="15.5"
                stroke="#B0C9EB"
            />
            <defs>
                <clipPath id="clip0_1_720">
                    <rect width="32" height="32" rx="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_1_720">
                    <rect
                        width="23"
                        height="21"
                        fill="white"
                        transform="translate(6 6)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default Ideal;
